import { Layout, Text } from 'ds';
import AddQuantity from 'ds/AddQuantity';
import { ConsumablesProduct, ConsumablesProductSubscription } from 'shared';
import { selectConsumablesOrders, selectProductSubscriptions } from 'store/Consumables/selectors';
import { useAppSelector } from 'store/hooks';

interface ConsumablesProductAddQuantityProps {
  selectedProductQuantity: number;
  setSelectedProductQuantity: (quantity: number) => void;
  title: string;
  showRemoveItemButton?: boolean;
  handleRemoveItem?: () => void;
  minValue?: number;
  selectedProduct: ConsumablesProduct | null;
}

const ConsumablesProductAddQuantity = ({
  selectedProductQuantity,
  setSelectedProductQuantity,
  title,
  showRemoveItemButton = false,
  handleRemoveItem,
  minValue = 1,
  selectedProduct
}: ConsumablesProductAddQuantityProps) => {
  const productSubscriptions = useAppSelector(selectProductSubscriptions);
  const consumablesOrders = useAppSelector(selectConsumablesOrders);
  const productSubscription = productSubscriptions?.find(
    (subscription: ConsumablesProductSubscription) => subscription.consumables_product.id === selectedProduct?.id
  );
  return (
    <Layout color="white" direction="column" paddingTop={24} gap={12}>
      <Text size="body-sm" color="gray-700" semibold>
        {title}
      </Text>
      <AddQuantity
        handleRemoveItem={handleRemoveItem}
        textAndIconColor="gray-900"
        value={selectedProductQuantity}
        size="lg"
        handleDecreaseQuantity={() => {
          if (selectedProductQuantity > minValue) {
            setSelectedProductQuantity(selectedProductQuantity - 1);
          }
        }}
        handleIncreaseQuantity={() => setSelectedProductQuantity(selectedProductQuantity + 1)}
        showRemoveItemButton={showRemoveItemButton}
        minValue={minValue}
      />
      <Layout paddingBottom={12}>
        <Text size="body-sm" color="gray-400" align="center">
          {productSubscription &&
            (selectedProductQuantity !== productSubscription.order_quantity ||
              !consumablesOrders ||
              consumablesOrders.length === 0) &&
            `${productSubscription.order_quantity} in your ${
              !consumablesOrders || consumablesOrders.length === 0 ? 'cart' : 'current subscription'
            }`}
        </Text>
      </Layout>
    </Layout>
  );
};

export default ConsumablesProductAddQuantity;
